import Drift from 'drift-zoom';


const initImageZoom = () => {
    const productImage = document.querySelector('.product-image');
    if (productImage && window.innerWidth>992) {
        const leftPane = document.querySelector('.summary-left-pane');
        new Drift(productImage, {
            paneContainer: leftPane,
            inlinePane: false,
            hoverBoundingBox: true
        });
    }

    
    //if (window.innerWidth<992) {
    //    const productGalleryImage = document.querySelector('.soheil-gallery-image');
    //    const leftPane = document.querySelector('.img-gallery-wrppaer');
    //    new Drift(productGalleryImage, {
    //        paneContainer: leftPane,
    //        inlinePane: false,
    //        hoverBoundingBox: true
    //    });
    //}


};

export {
    initImageZoom
};
